import { useQuery } from '@tanstack/react-query'
import { DeprecatedSingleSelectOption } from '@opallabs/lapidary'
import { customFieldTypes } from '../../../v3/customFieldTypes'
import { globalQueryKeys } from '../../queryKeys'
import { systemTypeToIcon, systemTypeToLabel } from './utils'

export function useGetCustomFieldTypes() {
  return useQuery({
    queryKey: globalQueryKeys.customFieldTypes(),
    queryFn: () => customFieldTypes.readCollection(),
    select(responseDocument) {
      return responseDocument.data.map<
        DeprecatedSingleSelectOption & { id: string }
      >((fieldType) => {
        return {
          id: fieldType.id,
          value: fieldType.attributes.system_type,
          label: systemTypeToLabel[fieldType.attributes.system_type],
          description: fieldType.attributes.description ?? '',
          leadingIcon: {
            glyph: systemTypeToIcon[fieldType.attributes.system_type],
            visibility: 'always',
          },
        }
      })
    },
  })
}
